import store from '@/store'
import CONST from './const';
import Utils from './utils';

export default class exportCSV {
  static genCSVFile(rows, filename) {  
    // const rows = [ ["name1", "city1", "some other info"] , ["name2", "city2", "more info"] ] //is 2-dimension array:
    let csvContent = "";

    rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
    });

    // const encodedUri = encodeURI(csvContent); // window.open and encodeURI functions to download the CSV file
    // window.open(encodedUri);

    //改檔案名稱、中文編碼
    const blob = new Blob(["\ufeff"+csvContent], { type: 'text/csv,charset=UTF-8' }); //new way
    const csvUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", csvUrl);
    link.setAttribute("download", filename? filename : `CSV_export.csv`);
    document.body.appendChild(link); // Required for FF


    link.click(); // This will download the data file named "CSV_export.csv"
  }
}